import { createReducer } from 'redux-create-reducer'
import type { PlaylistCurated } from 'types/playlist'
import {
  PLAYLISTS_CURATED_LOAD,
  PLAYLISTS_CURATED_LOAD_FAIL,
  PLAYLISTS_CURATED_LOAD_SUCCESS,
} from '@disco/constants/ActionTypes'
export type State = {
  loading: boolean
  loaded: boolean
  items: PlaylistCurated[]
  error: Error | null | undefined
}
export const initialState: State = {
  loading: false,
  loaded: false,
  items: [],
  error: null,
}
export const playlistsCuratedReducer = createReducer<State, any>(initialState, {
  [PLAYLISTS_CURATED_LOAD](state) {
    return { ...state, loading: true, loaded: false }
  },

  [PLAYLISTS_CURATED_LOAD_SUCCESS](state, { results }) {
    return { ...state, loading: false, loaded: true, items: results }
  },

  [PLAYLISTS_CURATED_LOAD_FAIL](state, { error }) {
    return { ...state, loading: false, loaded: false, error }
  },
})
